module.exports = __webpack_public_path__ + "img/cover-placeholder.dab0f7e9.svg";